import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface SettingsPopupProps {
  onlyDrivers?: boolean;
  setOnlyDrivers?: (value: boolean) => void;
  showArchived?: boolean;
  setShowArchived?: (value: boolean) => void;
  vehicleStatus?: boolean;
  setVehicleStatus?: (status: boolean) => void;
  /**
   * Whether the archive filters are offered.
   *
   * The route page shows journeys of active vehicles only, so the two archive switches would do
   * nothing there.
   */
  allowArchivedFilters?: boolean;
  /**
   * Whether the driver options are offered.
   *
   * The check page lists trips of vehicles and has no driver filter, so it would show a section
   * whose controls do nothing.
   */
  showDriverOptions?: boolean;
}

const SettingsPopup: React.FC<SettingsPopupProps> = ({
  onlyDrivers = false,
  setOnlyDrivers,
  showArchived = false,
  setShowArchived,
  vehicleStatus = false,
  setVehicleStatus,
  showDriverOptions = true,
  allowArchivedFilters = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const theme = useTheme();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { t } = useTranslation();
  return (
    <>
      <IconButton onClick={handleClick}>
        <SettingsIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: { width: "250px" },
        }}
      >
        <Box p={2}>
          {showDriverOptions && (
            <>
              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
                {t("user")}
              </Typography>

              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={onlyDrivers}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setOnlyDrivers?.(event.target.checked)
                      }
                    />
                  }
                  label={t("logbook.onlyDrivers")}
                />
                {allowArchivedFilters && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showArchived}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          setShowArchived?.(event.target.checked)
                        }
                      />
                    }
                    label={t("logbook.showArchived")}
                  />
                )}
              </FormGroup>
            </>
          )}
          {allowArchivedFilters && (
            <>
              <Typography
                variant="subtitle1"
                gutterBottom
                style={{
                  fontWeight: 600,
                  marginTop: showDriverOptions ? theme.spacing(2) : undefined,
                }}
              >
                {t("device")}
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={vehicleStatus}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setVehicleStatus?.(event.target.checked)
                      }
                    />
                  }
                  label={t("logbook.showArchived")}
                />
              </FormGroup>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default SettingsPopup;
